export type BrowserStorageKind = 'local' | 'session';

function resolveStorage(kind: BrowserStorageKind): Storage | null {
  try {
    return kind === 'local'
      ? (globalThis.localStorage ?? null)
      : (globalThis.sessionStorage ?? null);
  } catch {
    return null;
  }
}

export function readStoredJson(kind: BrowserStorageKind, key: string): unknown | null {
  try {
    const raw = resolveStorage(kind)?.getItem(key);
    return raw ? (JSON.parse(raw) as unknown) : null;
  } catch {
    return null;
  }
}

export function writeStoredJson(kind: BrowserStorageKind, key: string, value: unknown): boolean {
  try {
    const storage = resolveStorage(kind);
    if (!storage) return false;
    storage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function removeStoredValue(kind: BrowserStorageKind, key: string): void {
  try {
    resolveStorage(kind)?.removeItem(key);
  } catch {
    // Browser persistence is optional; state continues in memory when storage is unavailable.
  }
}
